import { render, staticRenderFns } from "./Politique.vue?vue&type=template&id=58cabe1d&scoped=true&"
import script from "./Politique.vue?vue&type=script&lang=js&"
export * from "./Politique.vue?vue&type=script&lang=js&"
import style0 from "./Politique.vue?vue&type=style&index=0&id=58cabe1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cabe1d",
  null
  
)

export default component.exports